import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { appMatDialogDefaultConfig } from '../../../../../helper/helper';
import { FormArray } from '@angular/forms';
import {
    arlBaseCostAllowanceFormGroup,
    arlBaseCostAllowanceType,
    getARLBaseCostAllowanceForm,
} from '../../arl-form-data.service';
import { Inject } from '@angular/core';
import { ArlAllowanceDialogComponentDialogData } from '../arl-allowance-dialog/arl-allowance-dialog.component';
import { getErrorMessage } from '../../../../../helper/validation.helper';
import {
    AccountsReceivableLedgerTypeEnum
} from '../../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export abstract class ArlChargeDialogBase {
    static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        disableClose: true,
        minWidth: '30rem',
    };
    protected shownArlAllowanceFormArray: Array<arlBaseCostAllowanceFormGroup>;
    private shownArlAllowanceFormArrayChanged$: Subject<void> = new Subject();
    protected shownArlAllowanceFormArray$: Observable<typeof this.shownArlAllowanceFormArray>;

   constructor(protected arlAllowanceFormArray: FormArray<arlBaseCostAllowanceFormGroup>) {
        this.setShownArlAllowanceFormArray();
        this.shownArlAllowanceFormArray$ = this.shownArlAllowanceFormArrayChanged$.pipe(startWith(null), map(() => this.shownArlAllowanceFormArray))
    }
    protected abstract filterAllowanceCharges(form:  arlBaseCostAllowanceFormGroup): boolean;
    private setShownArlAllowanceFormArray() {
        this.shownArlAllowanceFormArray = this.arlAllowanceFormArray.controls.filter((c) => this.filterAllowanceCharges(c));
        this.shownArlAllowanceFormArrayChanged$.next();
    }
    public GetErrorMessage = getErrorMessage;
    protected invalid() {
        return this.shownArlAllowanceFormArray.some((c) => c.invalid);
    }
    protected remove(index: number) {
        const i = this.arlAllowanceFormArray.controls.indexOf(this.shownArlAllowanceFormArray[index]);
        if (i !== -1) {
            this.arlAllowanceFormArray.removeAt(i);
            this.arlAllowanceFormArray.markAsDirty();
            this.setShownArlAllowanceFormArray();
        } else {
            throw 'index not found';
        }
    }
    protected add(arlBaseCostAllowanceFormGroup:  arlBaseCostAllowanceFormGroup) {
        if (this.filterAllowanceCharges(arlBaseCostAllowanceFormGroup)) {
            this.arlAllowanceFormArray.push(arlBaseCostAllowanceFormGroup);
            this.setShownArlAllowanceFormArray();
        } else {
            throw 'added arlBaseCostAllowanceFormGroup dos not pass filter-function';
        }
    }
}
